import React, { useState, useEffect } from 'react';
import '../App.css';

const News = () => {
  const [cryptoNews, setCryptoNews] = useState([]);

  useEffect(() => {
          const fetchData = async () => {
            
              try{
              const response = await fetch(
                  `https://gnews.io/api/v4/search?q=crypto&lang=en&max=10&sortBy=publishedAt&apikey=${process.env.REACT_APP_GNEWS_API_KEY}`);
              if (!response.ok) {
                  throw new Error('HTTP error! status: $ {response.status');
              }
              
              const result = await response.json();
              setCryptoNews(result.articles);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
            };
        fetchData();
    },[]);

   return cryptoNews ? (
    <section>
      <h1 className='font-bold text-3xl my-8 mx-6'>Crypto News</h1>
      <p className='text-xl text-gray-600 dark:text-gray-400 my-4 mx-6'>Stay updated with the latest cryptocurrency and blockchain news</p>
      <div className='mx-4'>
        {cryptoNews.map((item) => (
        <div key={item.id} className="p-8 mx-2 my-4 w-[95%] bg-color1 shadow-[0_0_10px_rgba(0,0,0,0.3)] dark:bg-gradient-to-br dark:from-[#09090b] dark:to-zinc-800 dark:border dark:border-zinc-700 rounded-xl">
            <p className='text-xl font-bold mb-4'>{item.title}</p>
            <p className='text-md text-gray-600 dark:text-gray-400 mb-2'>{item.description}</p>
            <p className='text-md text-gray-700 dark:text-gray-300'>Read more on <a href={item.url} className='underline'>{item.source.name}</a>...</p>
        </div>
        ))}
      </div>
    </section>
  ) : (
    <p>Loading...</p>
  );
}
export default News
